import React, { useState } from "react";
import "./settings.css";
import { NavLink, useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import OrderValidity from "./orderValidity";
import SettingsAccount from "./SettingsAccount";
import PrivacyPolicyView from "./PrivacyPolicyView";
import TermsConditionView from "./TermsConditionView";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";

const Settings = () => {
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/settings",
      breadcrumb: " / settings",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [orderValidity, setOrderValidity] = useState(11);
  const [activeAccount, setActiveAccount] = useState(21);
  const [activePrivacyPolicy, setActivePrivacyPolicy] = useState(31);
  const [activeTermsAndCondition, setActiveTermsAndCondition] = useState(41);
  const is_subscribed = localStorage.getItem("is_subscribed");

  return (
    <div className="products-page fn_Nunito">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1">
          <div className="search-container">
            {activeTab == 3 ? (
              <div className="d-flex justify-content-end align-items-center w-100">
                <AdminButton
                  className=""
                  background="#7065E4"
                  color="white"
                  width="80px"
                  onClick={() => {
                    navigate("/settings/privacy-policy/edit");
                  }}
                >
                  <span className="m-2">EDIT</span>
                </AdminButton>
              </div>
            ) : activeTab == 4 ? (
              <div className="d-flex justify-content-end align-items-center w-100">
                <AdminButton
                  className=""
                  background="#7065E4"
                  color="white"
                  width="80px"
                  onClick={() => {
                    navigate("/settings/terms-condition/edit");
                  }}
                >
                  <span className="m-2">EDIT</span>
                </AdminButton>
              </div>
            ) : (
              ""
            )}
          </div>
          {/* SIDE BAR */}
          <div className="d-lg-flex">
            <div className="d-md-flex">
              <div className="sidebar-container px- py-2 d-none d-lg-block">
                <div className="text-nowrap my-1">
                  <button
                    className={
                      activeTab == 1
                        ? "sidbarTabActive px-3 my-2 fw_500"
                        : "sidbarTab text-start color_747f9e px-3 my-2 fw_500"
                    }
                    onClick={() => {
                      setActiveTab(1);
                    }}
                  >
                    ORDER VALIDITY
                  </button>
                </div>
                <div className="text-nowrap my-1">
                  <button
                    className={
                      activeTab == 2
                        ? "sidbarTabActive px-3 my-2 fw_500"
                        : "sidbarTab text-start color_747f9e px-3 my-2 fw_500"
                    }
                    onClick={() => {
                      setActiveTab(2);
                    }}
                  >
                    ACCOUNT
                  </button>
                </div>
                {is_subscribed === "false" && (
                  <>
                    <div className="text-nowrap my-1">
                      <button
                        className={
                          activeTab == 3
                            ? "sidbarTabActive px-3 my-2 fw_500"
                            : "sidbarTab text-start color_747f9e px-3 my-2 fw_500"
                        }
                        onClick={() => {
                          setActiveTab(3);
                        }}
                      >
                        PRIVACY POLICY
                      </button>
                    </div>
                    <div className="text-nowrap my-1">
                      <button
                        className={
                          activeTab == 4
                            ? "sidbarTabActive px-3 my-2 fw_500"
                            : "sidbarTab text-start color_747f9e px-3 my-2 fw_500"
                        }
                        onClick={() => {
                          setActiveTab(4);
                        }}
                      >
                        TERMS & CONDITIONS
                      </button>
                    </div>
                  </>
                )}

                {/* <ul className="settings-sidebar-list">
                <li>
                  <span className="fs_14 Medium_Purple fw_600">
                    Order Validity
                  </span>
                </li>
              </ul> */}
              </div>

              {/* TOP BAR */}
              {/* <div className="d-flex d-lg-none">
              <Tabs
                defaultActiveKey="OrderValidity"
                id="controlled-tab-example"
                className="mb-3"
                transition={false}
              >
                <Tab eventKey="OrderValidity" title="Order Validity">
                  <OrderValidity />
                </Tab>
                <Tab eventKey="Options" title="Options 1"> </Tab>
                <Tab eventKey="Options2" title="Options 2"> </Tab>
              </Tabs>
            </div> */}

              <div className="d-lg-none">
                <div
                  className="my-1 py-2 d-sm-flex"
                  style={{ overflowX: "scroll" }}
                >
                  <div className="text-nowrap my-1">
                    <button
                      className={
                        activeTab == 1 ? "topbarTabActive mx-2" : "topTab mx-2"
                      }
                      onClick={() => {
                        setActiveTab(1);
                      }}
                    >
                      Order Validity
                    </button>
                  </div>
                  <div className="text-nowrap my-1">
                    <button
                      className={
                        activeTab == 2 ? "topbarTabActive mx-2" : "topTab mx-2"
                      }
                      onClick={() => {
                        setActiveTab(2);
                      }}
                    >
                      Account
                    </button>
                  </div>
                  {is_subscribed === "false" && (
                    <>
                      <div className="text-nowrap my-1">
                        <button
                          className={
                            activeTab == 3
                              ? "topbarTabActive mx-2"
                              : "topTab mx-2"
                          }
                          onClick={() => {
                            setActiveTab(3);
                          }}
                        >
                          Privacy Policy
                        </button>
                      </div>
                      <div className="text-nowrap my-1">
                        <button
                          className={
                            activeTab == 4
                              ? "topbarTabActive mx-2"
                              : "topTab mx-2"
                          }
                          onClick={() => {
                            setActiveTab(4);
                          }}
                        >
                          Terms and Condition
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="cont">
              {activeTab === 1 && <OrderValidity />}
              {activeTab === 2 && (
                <>{activeAccount === 21 && <SettingsAccount />}</>
              )}
              {activeTab === 3 && (
                <>{activePrivacyPolicy === 31 && <PrivacyPolicyView />}</>
              )}
              {activeTab === 4 && (
                <>{activeTermsAndCondition === 41 && <TermsConditionView />}</>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
